import { Accordion, Icon, Label, Message, Segment } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import React from "react";
import ResourceRow from "../ResourceRow";
import styles from "../Resources.module.css"

const DefaultLegalResourceSlide1 = (textTitle: string) => {
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Advanced Directives"
        url="https://www.nia.nih.gov/health/advance-care-planning-advance-directives-health-care"
        descriptionText="Advanced Directives for Health Care from the NIH"
        taskHeaderText={textTitle}
        groupedHeaderText="Resources on Advance Directives, Living Wills, and Health Care Proxies"
        />    
      <ResourceRow urlText="Alabama Advanced Directive Printable"
        url="https://www.alabamapublichealth.gov/cancer/assets/advdirective.pdf"
        descriptionText="Printable Advanced Directive for Health Care (If you reside in the state of Alabama)."
        />    
      <ResourceRow urlText="Trust Definitions"
        url="https://extension.umn.edu/transfer-and-estate-planning/trusts-definitions-types-and-taxation"
        groupedHeaderText="Resources on Trusts"
        />    
      <ResourceRow urlText="What is a trust?"
        url="https://www.tiaa.org/public/learn/retirement-planning-and-beyond/what-is-a-trust"
        descriptionText=""
        />    
      <ResourceRow urlText="What is a Power of Attorney?"
        url="https://www.consumerfinance.gov/ask-cfpb/what-is-a-power-of-attorney-poa-en-1149/"
        descriptionText=""
        groupedHeaderText="Resources on Financial Powers of Attorney"
        />    
      <ResourceRow urlText="Estate Planning & Power of Attorney"
        url="https://www.americanbar.org/groups/real_property_trust_estate/resources/estate_planning/power_of_attorney/"
        descriptionText=""
        />    
      <ResourceRow urlText="Power of Attorney Forms and Resources"
        url="https://www.lawdistrict.com/power-of-attorney/?utm_source=google&utm_medium=cpc&/?utm_source=google&utm_medium=cpc&gclid=EAIaIQobChMIwq7UvI2C_gIVoffjBx0WrQ-EEAAYASAAEgLdv_D_BwE"
        descriptionText=""
        /> 
      <ResourceRow urlText="Find a Lawyer"
        url="https://www.naela.org/findlawyer"
        descriptionText="The National Academy of Elder Law Attorney site on finding an elder law attorney."
        groupedHeaderText="Resources for Finding an Attorney for Estate Planning"
        />  
      <ResourceRow urlText="Finding an Attorney to Help with Estate Planning"
        url="https://www.caregiver.org/resource/finding-attorney-help-estate-planning/?via=caregiver-resources,all-resources"
        descriptionText="The Family Caregiver Alliance site on finding a lawyer for estate planning also includes information on important legal documents for seniors."
        />
      <ResourceRow urlText="Legal Assistance"
        url="https://alabamaageline.gov/legal-assistance/"
        descriptionText="Legal assistance for Alabama seniors."
        /> 
      <ResourceRow urlText="American Bar Association on Wills"
        url="https://www.americanbar.org/groups/real_property_trust_estate/resources/estate_planning/an_introduction_to_wills/"
        descriptionText=""
        groupedHeaderText="Resources on Wills"
        />  
      </Segment.Group>
    </>
  );
};

const DefaultLegalResourceSlide2 = (textTitle: string) => {
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
    <ResourceRow urlText="Budgeting for Older Adults"
      url="https://www.ncoa.org/older-adults/money/management/budgeting"
      descriptionText="Budgeting for Older Adults from National Council on Aging."
      taskHeaderText={textTitle}
      groupedHeaderText="Resources on Budgeting"
      />    
    <ResourceRow urlText="Budgeting Worksheet from AARP"
      url="https://www.aarp.org/content/dam/aarp/money/budgeting_savings/2014-08/budgeting-worksheet-aarp.pdf"
      descriptionText=""
      />    
    <ResourceRow urlText="What is a Reverse Mortgage?"
      url="https://www.consumerfinance.gov/ask-cfpb/what-is-a-reverse-mortgage-en-224/"
      descriptionText=""
      groupedHeaderText="Resources on Reverse Mortgages"
      />    
    <ResourceRow urlText="About Reverse Mortgages"
      url="https://consumer.ftc.gov/articles/reverse-mortgages"
      descriptionText=""
      /> 
    <ResourceRow urlText="Information on Home Equity Conversion Mortgages (HECM)"
      url="https://www.hud.gov/program_offices/housing/sfh/hecm/hecmhome"
      descriptionText=""
      />  
    <ResourceRow urlText="About Credit Reports"
      url="https://www.usa.gov/credit-reports"
      descriptionText=""
      groupedHeaderText="Resources on Credit Scores"
      />    
    <ResourceRow urlText="Information on Obtaining a Copy of a Credit Report"
      url="https://www.consumerfinance.gov/ask-cfpb/how-do-i-get-a-copy-of-my-credit-reports-en-5/"
      descriptionText=""
      />    
    {/* <ResourceRow urlText="Getting Your Affairs in Order"
      url="https://order.nia.nih.gov/sites/default/files/2018-06/getting-your-affairs-in-order.pdf"
      descriptionText="Getting Your Affairs in Order from the National Institute on Aging."
      /> */}
    </Segment.Group>
    </>
    );
};

const DefaultLegalResourceSlide3 = (textTitle: string) => {
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
    <ResourceRow urlText="National Council on Aging Benefits Check-Up"
      url="https://benefitscheckup.org/"
      descriptionText=""
      taskHeaderText={textTitle}
      />    
    <ResourceRow urlText="Comprehensive Site on Money Matters"
      url="https://www.aarp.org/money/"
      descriptionText="The American Association of Retired Persons provides a comprehensive site on money matters for older adults."
      />    
    <ResourceRow urlText="Social Security Administration"
      url="https://www.ssa.gov/"
      descriptionText="Site for the Social Security Administration"
      />
    <ResourceRow urlText="Veterans Benefits"
      url="https://benefits.va.gov/benefits/"
      descriptionText=""
      />    
    <ResourceRow urlText="Pension Benefit Guarantee"
      url="https://www.pbgc.gov/workers-retirees"
      descriptionText="Pension Benefit Guarantee Corporation on pension benefits."
      />
    <ResourceRow urlText="Pension Benefit Rights"
      url="https://www.pensionhelp.org/"
      descriptionText="The Pension Rights Center provides help on pension benefits."
      />    
    <ResourceRow urlText="Homestead Exemptions for Alabama Residents"
      url="https://www.revenue.alabama.gov/faqs/what-is-a-homestead-exemption/"
      descriptionText=""
      />    
    <ResourceRow urlText="Medicaid Chip Coverage"
      url="https://www.healthcare.gov/medicaid-chip/"
      descriptionText=""
      />
    <ResourceRow urlText="Things to Know about Medicaid"
      url="https://www.kff.org/medicaid/issue-brief/10-things-to-know-about-medicaid-setting-the-facts-straight/"
      descriptionText=""
      />    
    </Segment.Group>
    </>
  );
};

const DefaultLegalResourceSlide4 = (textTitle: string) => {
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
    {/* <ResourceRow urlText="Who Pays for Long-Term Care?"
      url="https://acl.gov/ltc/costs-and-who-pays/who-pays-long-term-care"
      descriptionText="Paying for Long Term Care from the Administration on Aging"
      />     */}
    <ResourceRow urlText="What is Long Term Care?"
      url="https://www.nia.nih.gov/health/what-long-term-care"
      descriptionText=""
      taskHeaderText={textTitle}
      groupedHeaderText="About Long Term Care"
      />
    <ResourceRow urlText="Long Term Care at Home"
      url="https://www.longtermcarelink.net/eldercare/long_term_care_at_home.htm"
      descriptionText=""
      />    
    <ResourceRow urlText="Long Term Care Facilities"
      url="https//www.nia.nih.gov/health/residential-facilities-assisted-living-and-nursing-homes"
      descriptionText=""
      />    
    <ResourceRow urlText="Paying for Long-Term Care"
      url="https://www.nia.nih.gov/health/paying-long-term-care"
      descriptionText="Paying for Long Term Care from the National Institute on Aging"
      groupedHeaderText="Paying for Long Term Care"
      />  
    <ResourceRow urlText="Veterans Paying for Long-Term Care"
      url="https://www.va.gov/geriatrics/pages/paying_for_long_term_care.asp"
      descriptionText="Long Term Care for Veterans."
      />
    <ResourceRow urlText="How Much Does Assisted Living Cost?"
      url="https://www.whereyoulivematters.org/how-much-does-assisted-living-cost/"
      descriptionText="Costs of Assisted Living from the American Seniors Housing Association."
      />  
    </Segment.Group>  
    </>
  );
};

const DefaultLegalResourceSlide5 = (textTitle: string) => {
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
    <ResourceRow urlText="Printable Template for Document Organization"
      url="http://assets.aarp.org/external_sites/caregiving/resources/pdfs/organize_documents.pdf"
      descriptionText=""
      taskHeaderText={textTitle}
      />    
    <ResourceRow urlText="Getting Your Affairs in Order Checklist"
      url="https://www.nia.nih.gov/health/getting-your-affairs-order"
      descriptionText=""
      />    
    <ResourceRow urlText="Tips for Organizing Documents"
      url="https://files.consumerfinance.gov/f/documents/cfpb_ymyg-servicemembers-tool_get-financial-legal-documents-in-order.pdf"
      descriptionText=""
      />
    <ResourceRow urlText="Organizing Paperwork"
      url="https://companionsforseniors.com/2020/05/organize-paperwork-documents-seniors/"
      descriptionText=""
      />
    </Segment.Group>
    </>
  );
};

const DefaultLegalResourceSlide6 = (textTitle: string) => {
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
    <ResourceRow urlText="Example of a State Real Property Record Website"
      url="https://alabama.staterecords.org/propertyrecords"
      descriptionText=""
      taskHeaderText={textTitle}
      />   
    </Segment.Group>
    </>
  );
};

const DefaultLegalResourceSlide7 = (textTitle: string) => {
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
    <ResourceRow urlText="Tips for Avoiding Inheritance Disputes"
      url="https://eeadmin.com/10-tips-for-avoiding-inheritance-disputes-over-family-heirlooms/"
      descriptionText="Tips for Avoiding Inheritance Displutes over family heirlooms."
      taskHeaderText={textTitle}
      />    
    <ResourceRow urlText="How to Pass Family Heirlooms"
      url="https://flaglawgroup.com/how-to-pass-on-family-heirlooms-keepsakes-without-causing-a-family-feud/#:~:text=Include%20items%20in%20your%20estate,as%20a%20personal%20property%20memorandum"
      descriptionText="How to pass on family heirlooms and keepsakes without causing a family feud."
      />    
    <ResourceRow urlText="Locating and Determining Family Heirlooms"
      url="https://www.nytimes.com/2022/11/30/learning/do-you-have-any-family-heirlooms.html"
      descriptionText=""
      />
    </Segment.Group>
    </>
  );
};

const DefaultLegalResourceSlide8 = (textTitle: string) => {
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
    <ResourceRow urlText="What is a Special Needs Trust?"
      url="https://www.specialneedsalliance.org/the-voice/your-special-needs-trust-snt-defined-2/"
      descriptionText=""
      taskHeaderText={textTitle}
      />    
    <ResourceRow urlText="Special Needs Trusts for Military Dependents"
      url="https://www.dfas.mil/retiredmilitary/provide/sbp/special-needs-trust/"
      descriptionText=""
      />    
    <ResourceRow urlText="Who needs a Special Needs Trust?"
      url="https://www.alabamafamilytrust.com/who-needs-a-special-needs-trusts/#:~:text=A%20special%20needs%20trust%20is,SSI)%20and%2For%20Medicaid"
      descriptionText=""
      />
    <ResourceRow urlText="Financial Planning Resources"
      url="https://thearc.org/financial-planning-resources/?gclid=Cj0KCQiA3eGfBhCeARIsACpJNU-0PDTwL0rLEPSV178HyopDkr2RW2Ctnr74Y0JPpidRenDbPMZEL_kaAk46EALw_wcB"
      descriptionText="Financial Planning Resources from The Arc"
      />
    <ResourceRow urlText="Planning for Adult Children with Special Needs"
      url="https://windwardlifecare.com/how-seniors-can-plan-for-their-adult-children-with-special-needs/"
      descriptionText=""
      />    
    <ResourceRow urlText="Connecting People with Disabilities"
      url="https://www.ablenrc.org/"
      descriptionText="Their families and those who support them to information about the Achieving a Better Life Experience (ABLE) Act and ABLE accounts."
      />
    </Segment.Group>
    </>
  );
};

const DefaultLegalResourceSlide9 = (textTitle: string) => {
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
    <ResourceRow urlText="Common Scams and Warning Signs"
      url="https://ovc.ojp.gov/program/stop-elder-fraud/common-scams-and-warning-signs"
      descriptionText=""
      taskHeaderText={textTitle}
      />    
    <ResourceRow urlText="Financial Scams Targeting Older Adults"
      url="https://ncoa.org/article/top-5-financial-scams-targeting-older-adults"
      descriptionText=""
      />    
    <ResourceRow urlText="Guide on Preventing Elder Financial Abuse"
      url="https://www.moneygeek.com/seniors/resources/elder-financial-abuse-prevention-guide/"
      descriptionText=""
      />
    <ResourceRow urlText="Scams & Identity Theft Trends"
      url="https://www.justice.gov/elderjustice/video/introducing-ftc-s-scams-and-identity-theft-older-adults-trends-tips-and-tools"
      descriptionText=""
      groupedHeaderText="Tips & Tools for Recognizing Scams"
      />
    <ResourceRow urlText="How identity Theft Impacts Seniors"
      url="https://www.ftc.gov/sites/default/files/documents/public_comments/ftc-seeks-public-input-how-identity-theft-impacts-senior-citizens-project-no.p065411-00009%C2%A0/00009-83187.pdf"
      descriptionText=""
      />
    <ResourceRow urlText="Prevent Elder Financial Exploitation"
      url="https://www.aarp.org/money/scams-fraud/info-2021/prevent-elder-financial-exploitation.html"
      descriptionText=""
      />    
    </Segment.Group>
    </>
  );
};

const accordionResourceDisplay = (keyVal: string, title: string, slideFunction: any) => {

  const accordions = [
    { key: 'keyVal',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.resourcesAccordionLabelTitleIcon} />, 
        content: <Label className={styles.resourcesAccordionLabelTitle} > {title} </Label> },
      content: { 
        content: (<Message className={styles.resourcesAccordionMessageBox} content={slideFunction()}/>)
      }
    }
  ];

  return (
    <>
    <div className={styles.resourceAccordionWrapper}>
      <Accordion panels={accordions} defaultActiveIndex={0} />
    </div>
    </>
  );

}

// 
const AllResources = () => {
  return (
    <>
      {accordionResourceDisplay('LegalDomainTask1', 'Legal Documents Resources', () => DefaultLegalResourceSlide1(""))}
      {accordionResourceDisplay('LegalDomainTask2', 'Budget Plan Resources', () => DefaultLegalResourceSlide2(""))}
      {accordionResourceDisplay('LegalDomainTask3', 'Exploring Benefits Resources', () => DefaultLegalResourceSlide3(""))}
      {accordionResourceDisplay('LegalDomainTask4', 'Long-Term Care Planning Resources', () => DefaultLegalResourceSlide4(""))}
      {accordionResourceDisplay('LegalDomainTask5', 'Organizing Documents Resources', () => DefaultLegalResourceSlide5(""))}
      {accordionResourceDisplay('LegalDomainTask6', 'Property Review Resources', () => DefaultLegalResourceSlide6(""))}
      {accordionResourceDisplay('LegalDomainTask7', 'Family Heirlooms Resources', () => DefaultLegalResourceSlide7(""))}
      {accordionResourceDisplay('LegalDomainTask8', 'Care of Dependents Resources', () => DefaultLegalResourceSlide8(""))}
      {accordionResourceDisplay('LegalDomainTask9', 'Preventing Fraud Resources', () => DefaultLegalResourceSlide9(""))}
    </>
  );
};

const LegalResourcesFactory: React.FC<{
  questionKey: string;
}> = (props) => {
  const { questionKey } = props;

  const renderResources = () => {
    switch (questionKey) {
      case "LegalDomainTask1":
        return DefaultLegalResourceSlide1('Legal Documents');
      case "LegalDomainTask2":
        return DefaultLegalResourceSlide2('Budget Plan');
      case "LegalDomainTask3":
        return DefaultLegalResourceSlide3('Exploring Benefits');
      case "LegalDomainTask4":
        return DefaultLegalResourceSlide4('Long-Term Care Planning');
      case "LegalDomainTask5":
        return DefaultLegalResourceSlide5('Organizing Documents');
      case "LegalDomainTask6":
        return DefaultLegalResourceSlide6('Property Review');
      case "LegalDomainTask7":
        return DefaultLegalResourceSlide7('Family Heirlooms');
      case "LegalDomainTask8":
        return DefaultLegalResourceSlide8('Care of Dependents');
      case "LegalDomainTask9":
        return DefaultLegalResourceSlide9('Preventing Fraud');
      case "":
        return AllResources();
      default:
        return null;
    }
  };

  return (
    <>
      {renderResources()}
    </>
  );
};
  

export default observer(LegalResourcesFactory);


